"use client";

/* eslint-disable jsx-a11y/anchor-is-valid */
import AmpService, { AMP_CATEGORY_LOCATIONS } from "analytics/amplitude/amplitudeEvents";
import CategoryViewItem from "component/categories-viewer/CategoryViewItem";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { memo } from "react";
import { useSelector } from "react-redux";
import HideIf from "util/HideIf";
import SafeLink from "modules/components/SafeLink";
import { mapSaleTagValue } from "./home-utils";
import styles from "./serviceCategory.module.scss";

function ServiceCategory(props: any) {
  const currentSelectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const { categoryData } = props;
  const {
    tier0, tier1, tier2, tier3,
  } = categoryData;

  const router = useRouter();
  const { t } = useTranslation("category-map");
  const homeT = (_: string, options) => t(_, { ...options, ns: "home" });

  const onClick = () => {
    router.push(categoryData.serviceUrl);
    AmpService.categoryClick({
      tier0, tier1, tier2, tier3,
    }, AMP_CATEGORY_LOCATIONS.REGULAR_SERVICE);
  };

  const {
    title,
    description,
    imageUrl,
    saleTagValue,
    saleTagTitle,
  } = categoryData;
  const altText = `Buy best quality ${title} for your car`;

  const child = (
    // <a onClick={onClick} className={styles.service_category_container} title={`Choose the Right ${title} for Your Vehicle`}>
    <>
      <PAImage
        className={`${styles.img_position} img`}
        src={`${process.env.NEXT_PUBLIC_CMS}/${imageUrl}`}
        alt={altText}
        title={altText}
        width={70}
        height={60}
      />
      <div className={styles.service_category_container}>
        <PAText component="h3" className={styles.link}>{t(title)}</PAText>

        <span className={styles.text}>{description}</span>

        <HideIf show={saleTagValue && saleTagValue !== 0 && saleTagTitle}>

          <div className={`${styles.saleBadge} ${styles[saleTagTitle]}`}>
            {mapSaleTagValue(saleTagTitle, saleTagValue, homeT)}
          </div>
        </HideIf>
      </div>

    </>
    // </a>
  );

  if (currentSelectedVehicle) {
    return (

      <CategoryViewItem
        categoryObj={{
          tier0: categoryData.tier0,
          tier1: categoryData.tier1,
          tier2: categoryData.tier2,
          tier3: categoryData.tier3,
        }}
        style={{ height: "100%" }}
      >
        {child}
      </CategoryViewItem>
    );
  }

  return (

    <SafeLink
      href={categoryData.serviceUrl}
      prefetch={false}
      onClick={onClick}
      // className={styles.service_category_container}
      title={`Choose the Right ${title} for Your Vehicle`}
    >
      {child}
    </SafeLink>

  );
}

export default memo(ServiceCategory);
